import { getShortAddress } from '../../../../../utils/address'

import { REQUEST_BOARD_CARD_LOCATION_SEPARATOR } from './RequestBoardCardLocation.constants'

function joinRequestBoardCardLocation(parts) {
  return parts.filter(Boolean).join(REQUEST_BOARD_CARD_LOCATION_SEPARATOR)
}

export function getRequestBoardCardLocation({ building, flat }) {
  return joinRequestBoardCardLocation([
    getShortAddress(building?.title),
    flat?.number,
  ])
}

export function getRequestBoardCardLocationTooltip({ building, flat }) {
  return joinRequestBoardCardLocation([building?.title, flat?.number])
}
